import React, { ReactNode, useContext, useEffect, useState } from 'react'

import UserStorage from '../../../storage/UserStorage/UserStorage'
import { BasePage, DesktopView, NeutralLink } from '../../projectComponents'
import { BubbleButtonContainer } from '../BubbleButtonContainer'

export const BasePageLayout = ({
  children,
  deferAuthContent = false,
  style,
}: {
  children: ReactNode
  deferAuthContent?: boolean
  style?: React.CSSProperties
}) => {
  const { isAuth } = useContext(UserStorage)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const showAuthContent = isAuth && (!deferAuthContent || isMounted)

  return (
    <BasePage style={style}>
      {children}
      {showAuthContent && (
        <DesktopView>
          <BubbleButtonContainer className={'buble_btn_container'} style={{ bottom: '36px' }}>
            <NeutralLink target={'_blank'} to={'https://t.me/Allsharing_support'}>
              <img height={50} src={'/images/buttons/headphones.svg'} width={50} />
            </NeutralLink>
          </BubbleButtonContainer>
        </DesktopView>
      )}
    </BasePage>
  )
}
